import { store } from '@/store'

import { HttpBuilder } from '@/utils/http/httpBuilder'
import { HttpResponse } from '@models/http/http-response'

const LOGIN_URL = '/app/Merchant/#/Login'

const selfDestruct = () => {
  setTimeout(function () {
    store.dispatch('user/resetUser')
    store.dispatch('resetAuthentication')
    window.location.replace(LOGIN_URL)
  }, 0)
}

export const generateDefaultHttpBuilder = () =>
  new HttpBuilder()
    .withUnauthorizedStrategy(selfDestruct)
    .withRetryFallbackStrategy(selfDestruct)

export const httpGetBuilder = () =>
  generateDefaultHttpBuilder()
    .asGet()

export const httpPostBuilder = () =>
    generateDefaultHttpBuilder()
      .asPost()

export const httpGetRawBuilder = () =>
  generateDefaultHttpBuilder()
    .asGet()
    .withSuccessStrategy((res) => res)

export const httpPostRawBuilder = (headers) =>
  generateDefaultHttpBuilder()
    .asPost()
    .withHeaders(headers)
    .withSuccessStrategy(toHttpResponse)
    .withFailedStrategy(toHttpResponse)

export const httpPutRawBuilder = (headers) =>
  generateDefaultHttpBuilder()
    .asPut()
    .withHeaders(headers)
    .withSuccessStrategy(toHttpResponse)
    .withFailedStrategy(toHttpResponse)

const toHttpResponse = res => new HttpResponse(res)
